/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
import config from '../config/index'

export const renderIf = predicate => elementOrThunk => {
    if (!predicate) return null

    return typeof elementOrThunk === 'function'
        ? elementOrThunk()
        : elementOrThunk
}

export function debounce(func, wait, immediate) {
    let timeout
    return function() {
        const context = this
        const args = arguments
        const later = function() {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

export function getFullUrl(url) {
    return url.indexOf(config.API_URI) === -1 ? config.API_URI + url : url
}
